import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import AppStoreLinks from 'components/atoms/AppStoreLinks/AppStoreLinks';
import { HOW_IT_WORKS, CASHBACK, SIGN_UP, PUBLIC_EARN } from 'components/pages/pages';
import Trustpilot from 'components/molecules/Trustpilot/Trustpilot';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import SplitRowCta from 'components/organisms/SplitRow/SplitRowCta';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import Button from 'components/atoms/Button/Button';
import A from 'components/atoms/A/A';
import Heading from 'components/atoms/Heading/Heading';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';

export interface Props {}

const LandingPageContent: React.FC<Props> = () => {
  return (
    <div>
      <Trustpilot
        title={
          <Heading level={2} uppercase>
            We&apos;re kind of a <span className="textHighlight">big deal...</span>
          </Heading>
        }
      />

      <SplitRow
        id="landingPageScrollToRow"
        leftColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_1.png"
            alt="What is a paid survey site?"
            width={600}
            height={600}
          />
        }
        rightColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Earn anytime,</span> anywhere
            </Heading>
            <Txt component="p">
              Make some money on your commute, get some extra cash in your downtime, or earn while
              you study. Download our iOS or Android app, or use Qmee from your browser, and let
              Qmee work for you.
            </Txt>
            <AppStoreLinks hideRating />
          </>
        }
      ></SplitRow>

      <SplitRow
        mobileColumnOrderSwapped
        rightColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_2.png"
            alt="Cash out however you want, whenever you want"
            width={600}
            height={600}
          />
        }
        leftColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Cash out</span> however you want, whenever you want
            </Heading>
            <Txt component="p">
              Have your rewards any way you choose! With no minimum cashout amount, and a variety of
              ways to withdraw your earnings including PayPal, Venmo and gift cards, you can cashout
              whenever you like, however you like.
            </Txt>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="primary"
                href={SIGN_UP.path}
                prefetch={false}
              >
                <Txt>Start Earning</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      ></SplitRow>

      <SplitRow
        leftColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_3.png"
            alt="Your opinion matters"
            width={600}
            height={600}
          />
        }
        rightColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Your opinion</span> matters
            </Heading>
            <Txt component="p">
              There&apos;s a reason survey providers pay for completed surveys - your opinion
              matters to them! By answering surveys with Qmee you can get your voice heard and{' '}
              <Txt component="strong">influence your favorite brands</Txt>.
            </Txt>
            <SplitRowCta>
              <Button component={A} color="secondary" href={PUBLIC_EARN.path} prefetch={false}>
                <Txt>View Surveys</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      ></SplitRow>

      <SplitRow
        mobileColumnOrderSwapped
        rightColumn={
          <LocaleAwareImage
            src="/assets/homepage_image_4.png"
            alt="Earn &amp; save when you shop with Qmee"
            width={600}
            height={600}
          />
        }
        leftColumn={
          <>
            <Heading level={2} uppercase>
              <span className="textHighlight">Earn &amp; save</span> when you shop with Qmee
            </Heading>
            <Txt component="p">
              Qmee not only has paid surveys - our hand-picked money earners let you earn real cash
              when you make a purchase. You can also get yourself some money off when you use our
              exclusive discount codes!
            </Txt>
            <SplitRowCta>
              <Button
                component={A}
                color="secondary"
                buttonType="secondary"
                href={CASHBACK.path}
                prefetch={false}
              >
                <Txt>Show me cashback deals</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
      ></SplitRow>

      <FullWidthCta
        title={
          <>
            How do <span className="textHighlight">paid surveys</span> work?
          </>
        }
        ctaText="Tell me more"
        ctaLink={HOW_IT_WORKS.path}
      >
        Get provided with online market research surveys that best match your profile,
        <br />
        then get a cash reward whenever you complete a survey.
      </FullWidthCta>
    </div>
  );
};

export default LandingPageContent;
